















































































import { defineComponent, toRefs, PropType, computed, watch } from '@vue/composition-api';
import AuthorizationVideoDetail from '../native-authorization/authorization-video-detail.vue';
import TutorialPreview from '../native-authorization/tutorial-preview.vue';
import { videoCodeValidator, fromVideoCodeValidator } from '../native-authorization/validator';
import { useAuthorizePost } from '../hooks/use-authorize-post';
import { AdgroupFormData, CampaignFormData, MaterialType } from '@tt4b/ttam-enums';
import { trackEvent } from '@tt4b/ttam-utils';
import Identity from '../index';

const STATES = {
  INIT: 1, // 初始状态
  FETCHED: 2, // 拉取到链接对应信息
  SUCCESS: 3, // 成功提交授权
};
const name = 'ttam-affiliate-authorize-post-compose';
export default defineComponent({
  name,
  components: {
    TutorialPreview,
    AuthorizationVideoDetail,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData } = toRefs(props);
    const {
      authorizationFormRef,
      authorizationForm,
      searchLoading,
      state,
      nativeVideo,
      videoCodeError,
      fromVideoCodeError,
      hasOriginalPost,
      isStateInit,
      isStateFetched,
      hasNativeVideo,
      title,
      videoCode,
      fromVideoCode,
      identityInfo,
      onClearCode,
      createSingleAuthorization,
      getNativeVideoInfo,
      getFromNativeVideoInfo,
    } = useAuthorizePost({
      teaParams: { isAffiliate: true },
    });

    const {
      dataSource: affiliateIdentityList,
      run: getAffilidateIdentityList,
      isLoading,
    } = Identity.useTikTokListDataSource({
      campaignData,
      adgroupData,
    });
    const onSuccess = async () => {
      await getAffilidateIdentityList();
      const identityData = affiliateIdentityList.value.find(identity => identity.identityId === identityInfo.value.id);
      emit('identity', identityData);
      emit('next', {
        creativeData: { ...nativeVideo.value },
        identityData,
      });
    };
    const isNextButtonAvailable = computed(() => {
      if (hasOriginalPost.value) {
        return Boolean(fromVideoCode.value);
      }
      return isStateFetched.value;
    });
    const init = () => {
      emit('valid-status', isNextButtonAvailable.value);
    };
    watch(isNextButtonAvailable, val => emit('valid-status', val));
    // 提供一个next方法让外部调用
    const next = () => {
      trackEvent('ad_start_with_product_authorize_post_submit');
      // 还没获取视频信息 不处理
      if (!isStateFetched.value) {
        authorizationFormRef.value?.validate?.();
        return;
      }
      // 单次授权
      if (!hasOriginalPost.value) {
        createSingleAuthorization({
          onSuccess,
        });
      } else {
        getFromNativeVideoInfo({
          onSuccess,
        });
      }
    };
    return {
      name,
      STATES,

      state,
      title,
      videoCode,
      isStateInit,
      nativeVideo,
      fromVideoCode,
      searchLoading,
      videoCodeError,
      hasNativeVideo,
      isStateFetched,
      hasOriginalPost,
      fromVideoCodeError,
      videoCodeValidator,
      authorizationForm,
      authorizationFormRef,
      fromVideoCodeValidator,

      onClearCode,
      getNativeVideoInfo,
      getFromNativeVideoInfo,
      init,
      next,
      onSuccess,
    };
  },
});
